var OCS = OCS || {}; //TODO: Complete work on file loading events. on_loading_phase_completed is not being fired properly
OCS.is_worker = false;
OCS.Classes = OCS.Classes || {};
OCS.Classes.Bootstrap = new Class({
    Implements: [Events],
    class_type: "Bootstrap",
    event_names: {},
    loading_phases: ["dependencies", "application"],
    current_load_phase: 0,
    bound_methods: {},
    load_file_paths: {
        dependencies: {
            standard: [],
            desktop: [],
            mobile: []
        },
        application: {
            standard: [],
            desktop: [],
            mobile: [],
            ie: []
        },
        optional: {}
    },
    package: {},
    protocol: document.location.protocol,
    debug: false,
    initialize: function () {
        console.log(this.class_type+': Initializing the boot sequence.');
        this.event_names.start = "start";
        this.event_names.file_loading_complete = "file_loading_complete";
        this.event_names.loading_phase_completed = "loading_phase_completed";
        this.event_names.loading_phase_start = "loading_phase_start";
        this.bound_methods.event_start = this.start.bind(this);
        this.bound_methods.start = this.on_start.bind(this);
        this.bound_methods.file_loading_complete = this.on_file_loading_complete.bind(this);
        this.bound_methods.loading_phase_completed = this.on_loading_phase_completed.bind(this);
        this.bound_methods.loading_phase_start = this.on_loading_phase_start.bind(this);
        this.bound_methods.optional_package_loaded = this.on_optional_package_loaded.bind(this);
    },
    // Actions
    init_events: function () {
        if (!this.debug) {
            var levents = Object.keys(this.event_names);
            levents.each(function (event_name) {
                if (this.bound_methods.hasOwnProperty(event_name)) {
                    this.addEvent(event_name, this.bound_methods[event_name]);
                }
            }, this);
        }
    },
    remove_events: function () {
        var levents = Object.keys(this.event_names);
        levents.each(function (event_name) {
            if (this.bound_methods.hasOwnProperty(event_name)) {
                this.removeEvent(event_name, this.bound_methods[event_name]);
            }
        }, this);
        this.removeEvents();
        this.$events = {};
    },

    add_to_load_file_paths: function (files) {
        if (files) {
            if (files.dependencies) {
                this.process_add_package_type('dependencies', files.dependencies, false);
            }
            if (files.application) {
                this.process_add_package_type('application', files.application, false);
            }
            if (files.optional) {
                this.process_add_package_type('optional', files.optional, true);
            }

        }
    },
    load_optional_package: function (category) {
        if (this.load_file_paths.optional[category]) {
            var load_ops = {load: this.load_file_paths.optional[category], onComplete: this.bound_methods.optional_package_loaded};
            if (load_ops.load.length) {
                OCS.DynamicScriptLoader.load(load_ops).catch(function (reason) {
                    console.debug(reason);
                }.bind(this));
            }
        }
    },
    process_add_package_type: function (package_type, files, allow_undefined_category) {
        var i, category_key;
        var categories = Object.keys(files);
        for (i = 0; i < categories.length; i++) {
            category_key = categories[i];
            if (allow_undefined_category && !this.load_file_paths[package_type].hasOwnProperty(category_key)) {
                this.load_file_paths[package_type][category_key] = [];
            }
            if (this.load_file_paths[package_type].hasOwnProperty(category_key)) {
                this.load_file_paths[package_type][category_key].combine(files[category_key]);
            }
        }
    },
    process_package: function () {
        if (!this.package || !Object.keys(this.package).length) {
            if (OCS.Package && (typeof OCS.Package === 'string' || OCS.Package instanceof String)) {
                this.package = JSON.parse(OCS.Package);
            }
            if (OCS.Package && typeof OCS.Package === "object") {
                this.package = OCS.Package;
            }
        }
        if (this.package && Object.keys(this.package).length) {
            if (this.package.files) {
                this.add_to_load_file_paths(this.package.files);
            }
        }
    },
    platform_startup: function (platform) {
        var url;
        switch (platform) {
            case 'mobile':
            case 'tablet':
                url = OCS.Mobile_url;
                break;
            default:
                url = OCS.Desktop_url;
                break;
        }
        var hash = '';
        if (window.location.hash) {
            hash = window.location.hash;
        }
        window.location.href = url + hash;
    },

    // Event Fires
    file_loading_complete: function () {
        this.fireEvent('file_loading_complete', this, 1);
    },
    loading_phase_completed: function () {
        if (!this.debug) {
            this.fireEvent(this.event_names.loading_phase_completed, this, 1);
        } else {
            console.debug(this.class_type + ": Debug mode! Ready to complete the " + this.loading_phases[this.current_load_phase] + " loading phase.");
            console.debug(this.class_type + ": To do so type 'OCS.Bootstrap.on_loading_phase_completed();' into the console.");
        }
    },
    loading_phase_start: function () {
        if (!this.debug) {
            if (this.loading_phases[this.current_load_phase]) {
                this.fireEvent(this.event_names.loading_phase_start, this, 1);
            } else {
                this.file_loading_complete();
            }
        } else {
            console.debug(this.class_type + ": Debug mode! Ready to start " + this.loading_phases[this.current_load_phase] + " loading phase.");
            console.debug(this.class_type + ": To do so type 'OCS.Bootstrap.on_loading_phase_start();' into the console.");
        }
    },
    process_content: function (element) {
        this.fireEvent("process_content", [element, this], 1);
    },
    start: function () {
        this.init_events();
        console.debug(this.class_type + ': Beginning startup sequence!');
        if (this.debug) {
            console.debug(this.class_type + ": Debug MODE ACTIVE! Please type OCS.Bootstrap.on_start() into the console to start the pre loading process.");
        } else {
            this.fireEvent(this.event_names.start, this, 1);
        }
    },

    // Event Listeners
    on_file_loading_complete: function () {
        console.log(this.class_type + ": File loading completed!");
        this.process_content();
        this.fireEvent('complete', this, 1);
    },
    on_loading_phase_completed: function () {
        OCS.Functions.run_boot_functions(this.loading_phases[this.current_load_phase]);
        this.current_load_phase++;
        this.loading_phase_start();
    },
    on_loading_phase_start: function () {
        var type = this.loading_phases[this.current_load_phase];
        if (this.load_file_paths[type]) {
            var files = [];
            
            var file_paths = this.load_file_paths[type];
            files.combine(file_paths.standard);
            if (OCS.device.desktop) {
                files.combine(file_paths.desktop);
            } else {
                files.combine(file_paths.mobile);
            }
            if (this.isIE() && file_paths.ie && file_paths.ie.length) {
                files.combine(file_paths.ie);
            }

            if (files.length) {
                var load_ops = {onComplete: this.loading_phase_completed.bind(this), load: files};
                OCS.DynamicScriptLoader.load(load_ops).catch(function (reason) {
                    console.debug(reason);
                    this.loading_phase_completed();
                }.bind(this));
                return;
            }
        }
        this.loading_phase_completed();
    },
    on_optional_package_loaded: function () {
        console.log(this.class_type + ": Optional file loading completed!");
        this.fireEvent('optional_complete', this, 1);
    },    
    on_start: function () {
        // Build the load from the package information we have
        this.process_package();
        if (!OCS.hasOwnProperty('device')) {
            OCS.device = {
                mobile: (device.mobile() || device.tablet()),
                tablet: device.tablet(),
                desktop: (!device.mobile() && !device.tablet())
            };
        }

        // Determine mobile or desktop
        var css_name;
        if (OCS.device.desktop) {
            css_name = 'desktop';
            document.body.className = document.body.className.replace('mobile', 'desktop');
            if (document.body.className.indexOf('desktop') === -1) {
                document.body.className = document.body.className + ' desktop';
            }
        } else {
            css_name = 'mobile';
            document.body.className = document.body.className.replace('desktop', 'mobile');
            if (document.body.className.indexOf('mobile') === -1) {
                document.body.className = document.body.className + ' mobile';
            }
            if (OCS.device.tablet) {
                if (document.body.className.indexOf('tablet') === -1) {
                    document.body.className = document.body.className + ' tablet';
                }
            }
        }
        // Start everything off with a clean slate.
        if (OCS.DynamicScriptLoader.job_manager.finished_loaded_scripts.length) {
            OCS.DynamicScriptLoader.remove({
                'remove': OCS.DynamicScriptLoader.job_manager.finished_loaded_scripts
            }).then(this.loading_phase_start.bind(this));
        } else {
            this.loading_phase_start();
        }


    },

    // Getters and Setters
    set_debug: function (val) {
        this.debug = val;
    },
    // Test
    isIE: function () {
        return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null)));
    },
    isEdge: function () {
        return (new RegExp("Edge").exec(navigator.userAgent) !== null);
    }
});
OCS.Bootstrap = new OCS.Classes.Bootstrap();
// Run this once the document reports ready
document.addEventListener('DOMContentLoaded', OCS.Bootstrap.bound_methods.event_start);

/**
 * THIS LINE SHOULD BE THE LAST LINE OF THE FILE
 * load DynamicScriptLoader and then begin the entire process of building the weather briefing page
 */



